 <template>
    <li>
      <h4 class="timeline-title">{{ item.imageName }}</h4>
    </li>
</template>


<script>
// https://vuejsexamples.com/a-simple-timeline-with-vue-js/
  export default {
      name: 'timeline-gallery',
      props: ['item'],      
      data() {
          return {             
          }
      },
  }
</script>

<style scoped>

.timeline-title {
  color: green;
}

</style>